import React from 'react'

import './FlexWrapper.less'

const FlexWrapper = ({children}) => {
  return (
    <div className='nmc-flex-wrapper'>
      {children}
    </div>
  )
}

export default FlexWrapper



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/FlexWrapper/index.js